import React, { useEffect, useState } from 'react'
import ReactECharts from "echarts-for-react"
import AiChartContextRegistration from "@/containers/facility/AiAssistant/AiChartContextRegistration";

export default function EChartsReact({ aiContext, ...props }) {

 const [isMounted, setIsMounted] = useState(false)

 useEffect(() => {
  setIsMounted(true)
 }, [])

  return isMounted ? (
    <>
      {aiContext ? <AiChartContextRegistration context={aiContext} /> : null}
      <ReactECharts {...props} />
    </>
  ) : null
}
